// This file is auto-generated by @hey-api/openapi-ts

export const tagTypes = [
  'assignments',
  'messages',
  'routes',
  'what-time-is-it',
  'public',
  'trips',
  'attendants',
  'billing',
  'dispatch',
  'drivers',
  'invoices',
  'members',
  'organizations',
  'passengers',
  'payers',
  'preferred-drivers',
  'run-bambi-run',
  'tags',
  'tilled',
  'user',
  'vehicles',
  'brokers',
  'Authentication',
  'credentials',
  'daily-digest',
  'die',
  'filters',
  'flags',
  'internal',
  'itinerary',
  'locations',
  'notifications',
  'organization-billing-status',
  'organization-billing-status-settings',
  'Organizations',
  'Payers',
  'Trips',
  'Webhooks',
  'passenger-import',
  'pricing',
  'reports',
  'signatures',
  'trip-import',
  'trip-request-embed',
] as const;
